import { Minus } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconMinus12Line = createIcon(Minus, 12, "Line");
export const IconMinus16Line = createIcon(Minus, 16, "Line");
export const IconMinus20Line = createIcon(Minus, 20, "Line");
export const IconMinus24Line = createIcon(Minus, 24, "Line");
export const IconMinus32Line = createIcon(Minus, 32, "Line");
export const IconMinus48Line = createIcon(Minus, 48, "Line");
export const IconMinus64Line = createIcon(Minus, 64, "Line");
